var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_152_233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 17,
    fill: "#FFA726"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.975 31.7125V25.05C21.975 24.2917 22.0125 23.55 22.0875 22.825C22.1625 22.0917 22.2625 21.3167 22.3875 20.5H24.475C24.6 21.3167 24.6958 22.0917 24.7625 22.825C24.8375 23.55 24.875 24.2917 24.875 25.05V31.7125H21.975ZM21.5 16.375C21.5 16.1083 21.5458 15.8625 21.6375 15.6375C21.7375 15.4042 21.8708 15.2042 22.0375 15.0375C22.2042 14.8708 22.4042 14.7417 22.6375 14.65C22.8708 14.55 23.1208 14.5 23.3875 14.5C23.6458 14.5 23.8917 14.55 24.125 14.65C24.3583 14.7417 24.5583 14.8708 24.725 15.0375C24.9 15.2042 25.0375 15.4042 25.1375 15.6375C25.2375 15.8625 25.2875 16.1083 25.2875 16.375C25.2875 16.6417 25.2375 16.8917 25.1375 17.125C25.0375 17.35 24.9 17.5458 24.725 17.7125C24.5583 17.8792 24.3583 18.0125 24.125 18.1125C23.8917 18.2125 23.6458 18.2625 23.3875 18.2625C23.1208 18.2625 22.8708 18.2125 22.6375 18.1125C22.4042 18.0125 22.2042 17.8792 22.0375 17.7125C21.8708 17.5458 21.7375 17.35 21.6375 17.125C21.5458 16.8917 21.5 16.6417 21.5 16.375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_152_233",
    x: 0.5,
    y: 0.5,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_152_233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_152_233",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.19e90c49511bd5bc631086f3387d9f5d.svg";
export { ForwardRef as ReactComponent };